export default __webpack_public_path__ + "static/media/balanceDisabled.e10a84cb.png";